import { render, staticRenderFns } from "./CourseHeader.vue?vue&type=template&id=61c8e98f&scoped=true"
import script from "./CourseHeader.vue?vue&type=script&lang=js"
export * from "./CourseHeader.vue?vue&type=script&lang=js"
import style0 from "./CourseHeader.vue?vue&type=style&index=0&id=61c8e98f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8e98f",
  null
  
)

export default component.exports